import React from "react";
import { Controller } from "react-hook-form";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import tenantStyles from "../../tenantlist.module.css";
import styles from "./addTenant.module.css";
import { LEASE_TYPE_NOTES } from "./fields";

const StepUnit = ({ control, errors, propertyList, apartmentList, selectedProperty, selectedApartment, leaseType, onPropertyChange, onApartmentChange, onLeaseTypeChange }) => {
  return (
    <div className={styles.StepBody}>
      <div className={styles.Grid2}>
        <div className="FormGroup">
          <FormControl fullWidth>
            <InputLabel id="add-tenant-property-label">Property*</InputLabel>
            <Controller
              name="property_id"
              control={control}
              defaultValue=""
              render={(field) => (
                <Select
                  {...field}
                  labelId="add-tenant-property-label"
                  label="Property*"
                  onChange={(e) => {
                    field.onChange(e);
                    onPropertyChange(e.target.value);
                  }}
                >
                  {propertyList?.map((item) => {
                    return (<MenuItem key={item.value} value={item.value} disabled={item?.apartments.length === 0}>{item.label} {(item?.apartments.length === 0) && <span className={tenantStyles.MenuItemSub}>(No vacancies)</span>}</MenuItem>);
                  })}
                </Select>
              )}
            />
          </FormControl>
          {errors.property_id && (<p className={tenantStyles.ErrorM}>{errors.property_id.message}</p>)}
        </div>
        <div className="FormGroup">
          <FormControl fullWidth>
            <InputLabel id="add-tenant-apartment-label" className={selectedProperty ? `` : `DisabledLabel`}>Apartment*</InputLabel>
            <Controller
              name="apt_id"
              control={control}
              defaultValue=""
              render={(field) => (
                <Select
                  {...field}
                  labelId="add-tenant-apartment-label"
                  label="Apartment*"
                  onChange={(e) => {
                    field.onChange(e);
                    onApartmentChange(e.target.value);
                  }}
                  disabled={!selectedProperty}
                >
                  {apartmentList?.map((item) => {
                    return (<MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>);
                  })}
                </Select>
              )}
            />
          </FormControl>
          {errors.apt_id && (<p className={tenantStyles.ErrorM}>{errors.apt_id.message}</p>)}
        </div>
      </div>

      <div className="FormGroup">
        <FormControl fullWidth>
          <InputLabel id="add-tenant-lease-type-label" className={selectedApartment ? `` : `DisabledLabel`}>Lease type*</InputLabel>
          <Controller
            name="lease_type"
            control={control}
            render={(field) => (
              <Select
                {...field}
                labelId="add-tenant-lease-type-label"
                label="Lease type*"
                onChange={(e) => {
                  field.onChange(e);
                  onLeaseTypeChange(e.target.value);
                }}
                disabled={!selectedApartment}
              >
                <MenuItem value="New">New Lease</MenuItem>
                <MenuItem value="Renewal">Lease Renewal</MenuItem>
                <MenuItem value="Existing">Existing Lease</MenuItem>
              </Select>
            )}
          />
        </FormControl>
        {errors.lease_type && (<p className={tenantStyles.ErrorM}>{errors.lease_type.message}</p>)}
      </div>

      {LEASE_TYPE_NOTES[leaseType] && (<div className={styles.Note}>{LEASE_TYPE_NOTES[leaseType]}</div>)}
    </div>
  );
};

export default StepUnit;
